import {
  USER_ROLES,
  USER_ROLES_DROPDOWN,
  USER_ROLES_DROPDOWN_APPROVAL_FLOW,
  USER_ROLES_NAMES_DROPDOWN,
} from "recoils";

export const ROLE_SELECT_OPTIONS = Object.values(USER_ROLES_DROPDOWN).map(
  (role) => USER_ROLES_NAMES_DROPDOWN[role],
);

export const ROLE_SELECT_OPTIONS_APPROVAL_FLOW = Object.values(
  USER_ROLES_DROPDOWN_APPROVAL_FLOW,
).map((role) => USER_ROLES_NAMES_DROPDOWN[role]);

export const COMMA_WHITE_SPACE_SEPARATED_EMAILS_REGEX =
  /^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})(, {1}[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/;

export const DEFAULT_VALUES = {
  emails: "",
  role: ROLE_SELECT_OPTIONS[0],
  sites: [],
  firstName: "",
  lastName: "",
};

export const USER_ROLE = [
  {
    label: USER_ROLES.AUDITOR,
    name: "Auditor",
    value: 1,
  },
  {
    label: USER_ROLES.DATA_PROVIDER,
    name: "Data Provider",
    value: 2,
  },
  {
    label: USER_ROLES.DATA_VALIDATOR,
    name: "Data Validator",
    value: 3,
  },
  {
    label: USER_ROLES.MODULE_ADMIN,
    name: "Module Admin",
    value: 4,
  },
];

export const USER_ROLE_APPROVAL_FLOW_OPTIONS = [
  {
    label: USER_ROLES.DATA_REVIEWER,
    name: "Data Reviewer",
    value: 5,
  },
];

export const STATUS_STYLES: Record<
  string,
  { backgroundColor: string; color: string }
> = {
  "invite sent": { backgroundColor: "#F0F0F0", color: "#6B7280" },
  active: { backgroundColor: "#E6F4EC", color: "#276749" },
  "active - sso": { backgroundColor: "#E6F4EC", color: "#276749" },
  "no invitation": { backgroundColor: "#FFF3E0", color: "#B45309" },
  "invite expired": { backgroundColor: "#FFF3E0", color: "#B45309" },
  disabled: { backgroundColor: "#E1EFE6", color: "#DD7615" },
};
